<h1 mat-dialog-title>Populate key dates</h1>
<div mat-dialog-content>
  <p>On proceeding all the key dates from the latest year will be copied into the next year.</p>
<p> Once this has completed, a new section will be available listing the generated dates, from which you should modify the start and end dates.</p>
</div>
<div mat-dialog-actions>
  <button mat-raised-button color="warn" (click)="onNoClick()">Cancel</button>
  <button mat-raised-button color="primary" (click) = "copyYear(data.year)" cdkFocusInitial>Proceed</button>
</div>
